import { render } from "./limit-time-modal.vue?vue&type=template&id=2dbecdff&ts=true"
import script from "./limit-time-modal.vue?vue&type=script&lang=ts"
export * from "./limit-time-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__